import {Component, input} from '@angular/core';
import {LoadState} from './gql-load';

/**
 * The loading / error row of a data table (castlabs-ui `cl-tr-no-data`):
 * `<tr appLoadRow [state]="rows()" thing="storage roots"></tr>`. Renders nothing once loaded, so the
 * table's own rows (and its "No data available." row) follow it.
 */
@Component({
  selector: 'tr[appLoadRow]',
  host: {'[class.cl-tr-no-data]': 'state().loading || !!state().error', '[hidden]': '!state().loading && !state().error'},
  template: `
    @if (state().loading) {
      <td colspan="100"><div class="cl-spinner">Loading ...<i class="fas fa-spinner fa-spin" aria-hidden="true"></i></div></td>
    } @else if (state().error) {
      <td colspan="100" role="alert">Could not load {{ thing() }}: {{ state().error }}</td>
    }`,
})
export class LoadRowComponent {
  readonly state = input.required<LoadState<unknown>>();
  /** What the table lists, for the message: "Could not load storage roots: ...". */
  readonly thing = input.required<string>();
}
